import * as languageCodeOptions from './export';

export function embedLocales(config) {
  let languageCode = config.languageCode || 'en';
  const customLocales = config.locales && config.locales[languageCode]

  if (languageCode.includes('-')) {
    languageCode = languageCode.replace('-','')
  }
  
  let locales = languageCodeOptions[languageCode];

  // keep 'en' as default language if languageCode is unknown
  if (!locales) { locales = languageCodeOptions['en'] }

  return {
    ...locales,
    ...(customLocales || {})
  }
}
